import { render, staticRenderFns } from "./AllocationChannelCreate.vue?vue&type=template&id=46e61a4f&scoped=true&"
import script from "./AllocationChannelCreate.vue?vue&type=script&lang=js&"
export * from "./AllocationChannelCreate.vue?vue&type=script&lang=js&"
import style0 from "./AllocationChannelCreate.vue?vue&type=style&index=0&id=46e61a4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e61a4f",
  null
  
)

export default component.exports